/* =====================================================================
 * Dimensions — sizes, radii, shadows, breakpoints, transitions.
 *
 * These are mode-agnostic (identical in light & dark). Identical to the
 * legacy `shared` block inside askyourai/src/theme/theme.ts.
 * ===================================================================== */

export const sizes = {
  sidebarWidth: '260px',
  maxMessageWidth: '768px',
  // 채팅 버블 칼럼 폭. 입력바(maxMessageWidth)와 분리해 버블만 넓게 둔다.
  maxBubbleWidth: '860px',
  inputMaxHeight: '200px',
  borderRadius: '12px',
  borderRadiusSm: '8px',
  borderRadiusLg: '24px',
  borderRadiusXl: '28px',
} as const;

export const shadows = {
  sm: '0 1px 2px rgba(0,0,0,0.06)',
  md: '0 4px 12px rgba(0,0,0,0.08)',
  lg: '0 8px 24px rgba(0,0,0,0.12)',
  input: '0 0 0 2px rgba(0, 0, 0, 0.1)',
} as const;

export const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1280px',
} as const;

export const transitions = {
  fast: '150ms cubic-bezier(0.4, 0, 0.2, 1)',
  normal: '250ms cubic-bezier(0.4, 0, 0.2, 1)',
  slow: '350ms cubic-bezier(0.4, 0, 0.2, 1)',
  spring: '400ms cubic-bezier(0.34, 1.56, 0.64, 1)',
} as const;

export type Sizes = typeof sizes;
export type Shadows = typeof shadows;
export type Breakpoints = typeof breakpoints;
export type Transitions = typeof transitions;
